var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'MainsConnection' },"device-icon":"main-connection","is-preview":true},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"d-flex mains-connection"},[_c('div',[_vm._v("2100 kW")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }